



































import {
  computed,
  defineNuxtComponent,
  ref,
  vue3Model,
  watch
} from '~/utils/nuxt3-migration'
import { addYears, format, parseDate } from '~/utils/date'
import CDatePicker from '~/components/shared/configurable/date/CDatePicker.vue'
import CFormGroup from '~/components/shared/configurable/form/CFormGroup.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { SIMPLE_DATE_FORMAT } from '~/constants/date'

const DATE_FORMAT = 'd/M/yyyy'

export default defineNuxtComponent({
  model: vue3Model,
  components: {
    CDatePicker,
    CFormGroup
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const facet = ref(props.modelValue)
    const dateFrom = ref<string | null>(
      parseSelectedDate(facet.value.values?.selected?.low)
    )
    const dateTo = ref<string | null>(
      parseSelectedDate(facet.value.values?.selected?.high)
    )

    watch(
      () => props.modelValue,
      newValue => {
        facet.value = {
          ...facet.value,
          ...newValue
        }

        dateFrom.value = parseSelectedDate(facet.value.values?.selected?.low)
        dateTo.value = parseSelectedDate(facet.value.values?.selected?.high)
      }
    )

    const datepickerFromMinDate = computed(() => {
      return today.value.toISOString()
    })
    const datepickerFromMaxDate = computed(() => {
      return oneYearLater.value.toISOString()
    })
    const datepickerToMaxDate = computed(() => {
      return oneYearLater.value.toISOString()
    })
    const datepickerToMinDate = computed(() => {
      return (
        (dateFrom.value && new Date(dateFrom.value).toISOString()) ||
        today.value.toISOString()
      )
    })
    const today = computed(() => {
      return new Date()
    })
    const oneYearLater = computed(() => {
      return addYears(today.value, 1)
    })

    function handleDateFromInput(date: Date) {
      emit('update:modelValue', {
        name: `${facet.value.urlargNames[0]}-from`,
        value: format(date, DATE_FORMAT)
      })
    }

    function handleDateToInput(date: Date) {
      emit('update:modelValue', {
        name: `${facet.value.urlargNames[0]}-to`,
        value: format(date, DATE_FORMAT)
      })
    }

    function parseSelectedDate(value: string | undefined) {
      if (!value) {
        return null
      }

      return parseDate(value, SIMPLE_DATE_FORMAT)
    }

    return {
      facet,
      dateFrom,
      dateTo,
      datepickerFromMinDate,
      datepickerFromMaxDate,
      datepickerToMaxDate,
      datepickerToMinDate,
      handleDateFromInput,
      handleDateToInput
    }
  },
  i18n: defineComponentTranslations({
    rental_period: {
      en: 'Rental period',
      el: 'Ημέρες ενοικίασης'
    }
  })
})
